<template>
  <section class="colored section">
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(validateBeforeSubmit)">
        <h2 class="title">{{ $t('3 Detalles Financieros') }}</h2>
        <p>
          {{ $t('Los campos marcados con asterisco (*) son obligatorios.') }}
        </p>
        <br />
        <b-field expanded :label="$t('¿Qué financiación estás buscando?')">
          <b-input expanded v-model="formData.financingType"></b-input>
        </b-field>
        <b-field expanded :label="$t('Ingresos (Anuales)')">
          <b-input expanded v-model="formData.income"></b-input>
        </b-field>
        <b-field expanded :label="$t('Gastos (Anuales)')">
          <b-input expanded v-model="formData.expenses"></b-input>
        </b-field>
        <div class="has-text-centered">
          <b-button size="is-large" native-type="submit" type="is-primary">{{
            $t('Guardar')
          }}</b-button>
        </div>
      </form>
    </ValidationObserver>
  </section>
</template>
<script>
import { ValidationObserver } from 'vee-validate'
export default {
  components: {
    ValidationObserver
  },
  props: {
    financialDetails: {
      type: Object,
      default: function() {
        return {
          financingType: null,
          income: null,
          expenses: null
        }
      }
    }
  },
  watch: {
    financialDetails: function(val) {
      this.formData = val
    }
  },
  data() {
    return {
      formData: null
    }
  },
  beforeMount() {
    this.formData = this.financialDetails
  },
  methods: {
    validateBeforeSubmit() {
      this.$emit('formSubmit', { financialDetails: this.formData })
    }
  }
}
</script>

<style scoped></style>
